var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumericallyDesc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22l6-8h-4v-12h-4v12h-4l6 8zm12.43-4.814v-.934c.352-.015 1.901.029 1.901-1.232h1.146v6.98h-1.407v-4.814h-1.64zm-.927-14.097c.646-.694 1.647-1.089 2.666-1.089 1.319 0 2.667.663 3.311 2.194.346.824.52 1.907.52 3.251 0 3.048-.947 5.757-3.994 5.757-1.606 0-3.099-.968-3.288-2.812h2.112c.099.628.542 1.071 1.272 1.071 1.445 0 1.693-1.601 1.763-3.027-1.033 1.299-3.106 1.15-4.366.026-1.388-1.238-1.291-3.98.004-5.371zm3.566 4.282c.481-.308.722-.841.722-1.599 0-.61-.143-1.093-.428-1.451-.285-.357-.676-.536-1.172-.536-.362 0-.671.102-.93.305-.406.317-.609.855-.609 1.614 0 .64.13 1.119.391 1.439.26.32.66.48 1.201.48.293.001.568-.084.825-.252z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumericallyDesc);
export default __webpack_public_path__ + "static/media/numerically-desc.5a237014.svg";
export { ForwardRef as ReactComponent };